export const parseJwtPayload = token => {
  const base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  return JSON.parse(b64DecodeUnicode(base64));
};
export const parseJwtHeader = token => {
  const base64Url = token.split(".")[0];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  return JSON.parse(b64DecodeUnicode(base64));
};

function b64DecodeUnicode(str) {
  // Going backwards: from bytestream, to percent-encoding, to original string.
  try {
    return decodeURIComponent(
      window
        .atob(str)
        .split("")
        .map(function(c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
  } catch (error) {
    return "{}";
  }
}
